import React, { useCallback, useEffect, useState } from "react";
import PhotographerTable from "../PhotographerTable/PhotographerTable";
import { getVerifiedPhotographersAPI } from "../../../utils/APIs/photographersApis";
import Loader from "../../../Loader/Loader";
// import { getVerifiedPhotographersAPI } from "your-api-file";

const VerifiedPhotographerTable = () => {
  const [verifiedData, setVerifiedData] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const LIMIT = 10;

  const fetchData = useCallback(async (pageNo = page) => {
    setLoading(true);
    try {
      const res = await getVerifiedPhotographersAPI(pageNo, LIMIT);

      setVerifiedData(res?.data?.photographers || []);
      setTotal(res?.data?.meta?.total || 0);
      setPage(res?.data?.meta?.page || pageNo);
    } catch (err) {
      console.error("Verified photographers fetch failed", err);
    } finally {
      setLoading(false);
    }
  }, [page]);

  useEffect(() => {
    fetchData(page);
  }, [fetchData,page]);

  const totalPages = Math.ceil(total / LIMIT);

  const getPageNumbers = () => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
    return pages;
  };

  if(loading){
    return <Loader/>
  }

  return (
    <>
      <PhotographerTable
        data={verifiedData}
        showVerify={false}
        page={page}
        limit={LIMIT}
        refreshData={() => fetchData(page)}
      />

      {totalPages > 1 && (
        <div className="pagination">
          {/* Prev */}
          <button
            className="pagination-btn"
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            Prev
          </button>

          {/* Page Numbers */}
          {getPageNumbers().map((p) => (
            <button
              key={p}
              className={`pagination-btn ${p === page ? "active" : ""}`}
              onClick={() => setPage(p)}
            >
              {p}
            </button>
          ))}

          {/* Next */}
          <button
            className="pagination-btn"
            disabled={page === totalPages}
            onClick={() => setPage(page + 1)}
          >
            Next
          </button>
        </div>
      )}
    </>
  );
};

export default VerifiedPhotographerTable;
